import { render, staticRenderFns } from "./kuspitAccountLinkingForgetPassword.vue?vue&type=template&id=8902fe5a&"
import script from "./kuspitAccountLinkingForgetPassword.vue?vue&type=script&lang=ts&"
export * from "./kuspitAccountLinkingForgetPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VImg,VRow})
